import styled from "styled-components";

export const StyledTableRow = styled.tr<{ $disabled: boolean }>`
  ${({ $disabled }) =>
    $disabled &&
    `
    color: var(--ons-color-grey-35, #bcbcbd);

    a {
      color: var(--ons-color-grey-35, #bcbcbd);
    }
  `}
`;
